import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-paperless',
  templateUrl: './icon-paperless.component.html',
  styleUrls: ['./icon-paperless.component.scss'],
  standalone: false,
})
export class IconPaperlessComponent {
  @Input() color = '#059669';
  @Input() width = '24';
  @Input() height = '24';
}
